import * as React from "react";
import { Icon } from "sb-resp-ui";
export class CloseButton extends React.Component {
    render() {
        const { handler } = this.props;
        return (React.createElement("button", { className: "rj-pulse-bet-markets__close-button", onClick: handler },
            React.createElement(Icon, { i: "i-12 i-o-pulsebet-clear" })));
    }
}
//# sourceMappingURL=CloseButton.js.map